<template>
  <div class="accordion-item">
    <div class="accordion-header" @click="toggleAccordion">
      <h2 class="accordion-title">
        <a class="accordion-toggle" :class="{ 'collapsed': !isOpen }">
          <div class="accordion-title-content">
            <i v-if="icon" :class="['fa', `fa-${icon}`, 'header-icon']"></i>
            {{ title }}
            <slot name="indicator"></slot>
          </div>
          <i class="fa" :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </a>
      </h2>
    </div>

    <div :class="['accordion-collapse', { 'show': isOpen }]">
      <div class="accordion-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    initialOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.initialOpen
    }
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', { isOpen: this.isOpen });
    },
    closeAccordion() {
      this.isOpen = false;
    },
    openAccordion() {
      this.isOpen = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-item {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  margin-bottom: 15px;
  overflow: hidden;
}

.accordion-header {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #e9ecef !important; 
  }
  
  .accordion-title {
    margin: 0;
    font-size: 1rem !important;
    line-height: 1.4 !important;
  }
}

.accordion-toggle {
  color: #1C2D5A !important;
  font-weight: 500 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none !important;
  width: 100%;
  
  .accordion-title-content {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
  }
  
  &.collapsed i.fa-chevron-up {
    transform: rotate(180deg);
  }
  
  &:hover {
    color: #0d1b3a !important;
  }
  
  i.fa {
    font-size: 0.85rem;
  }
}

.header-icon {
  margin-right: 10px;
  color: #1C2D5A !important;
  font-size: 0.9rem;
}

.accordion-collapse {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  
  &.show {
    max-height: 100%; /* Valor alto o suficiente para acomodar qualquer conteúdo */
  }
}

.accordion-body {
  padding: 25px;
  background-color: #ffffff !important;
}
</style>
